import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { class: "card-header" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("btn.manualPreview")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: _ctx.data,
      stripe: "",
      style: {"width":"100%"},
      "scrollbar-always-on": "",
      "default-sort": { prop: 'dateTime', order: 'ascending' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "left",
          prop: "dateTime",
          label: _ctx.$t('label.date') + ' (UTC)',
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_ctx.dateFormatDate(scope.row.dateTime)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "magnitude",
          label: _ctx.$t('label.magnitude')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "codeParameter",
          label: _ctx.$t('label.code')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "raw",
          label: _ctx.$t('label.raw')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "clean",
          label: _ctx.$t('label.clean')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          sortable: "",
          prop: "value",
          label: _ctx.$t('label.value')
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      class: "app-table",
      layout: "total, sizes, prev, pager, next, jumper",
      currentPage: _ctx.currentPage,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
      "page-sizes": [10],
      "page-size": _ctx.rowPerPage,
      total: _ctx.totalRows,
      onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePaginationSize($event))),
      onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePaginationPage($event)))
    }, null, 8, ["currentPage", "page-size", "total"])
  ], 64))
}